// Import controller interfaces
import {
    ISignUpController
} from '../Interfaces/ControllerInterfacesBarrel';
// Import api models.
import {
    NewProducer,
    PossibleBusinessType,
    PossibleHeardThroughOption,
    PossibleMasterProducer
} from '@app/models/api';

export default class MockSignUpController implements ISignUpController {

    public constructor() {

    }

    public async getPossibleBusinessTypes(): Promise<PossibleBusinessType[]> {
        throw new Error('Method not implemented.');
    }

    public async getPossibleProducerAgencies(): Promise<PossibleMasterProducer[]> {
        throw new Error('Method not implemented.');
    }

    public async createProducer(newProducer: NewProducer): Promise<number> {
        throw new Error('Method not implemented.');
    }

    public async getPossibleHeardThroughOptions(): Promise<PossibleHeardThroughOption[]> {
        throw new Error('Method not implemented.');
    }
};